import { render, staticRenderFns } from "./ReviewAccommodationHeader.vue?vue&type=template&id=54a3287c&scoped=true&"
import script from "./ReviewAccommodationHeader.vue?vue&type=script&lang=js&"
export * from "./ReviewAccommodationHeader.vue?vue&type=script&lang=js&"
import style0 from "./ReviewAccommodationHeader.vue?vue&type=style&index=0&id=54a3287c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a3287c",
  null
  
)

export default component.exports